import { createElement } from 'react';
import { useDesignTokens, renderInlineCssVars } from '../../../theme';
import { Flow } from '../../Layouts/Flow';
import { Node } from '../../Tree';
import { Link } from '../../Link';
import { Heading } from '../../Heading';
import { TestIdProps, postfixTestId } from '../../../util/testId';

import cn from './FormGroupNavigation.css.json';
import './FormGroupNavigation.css';

export interface FormGroupNavigationProps extends TestIdProps {
  id: string;
  heading: string;
  nodes: Array<Pick<Node, 'id' | 'text'>>;
  onItemPress: (routeId: string) => void;
}

export const FormGroupNavigation = ({
  id,
  heading,
  nodes,
  onItemPress,
  ...testIdProps
}: FormGroupNavigationProps) => {
  const dt = useDesignTokens();
  const tokens = renderInlineCssVars(
    { 'font-weight-thick': dt.fontNova.weight.thick },
    'form-group-navigation'
  );
  return (
    <Flow orientation="vertical" style={tokens} className={cn.container}>
      <header className={cn.header}>
        <Heading level={5} wrapText={false} className={cn.headerTitle} id={`${id}-header`}>
          {heading}
        </Heading>
      </header>
      <section className={cn.content}>
        <Flow orientation="vertical" spacing="none">
          {nodes.map((node, index) => {
            return (
              <Link
                testId={postfixTestId(testIdProps.testId, `link-${index}`)}
                key={node.id}
                onPress={() => onItemPress(node.id)}
              >
                {node.text}
              </Link>
            );
          })}
        </Flow>
      </section>
    </Flow>
  );
};
